// Other platforms retain the existing composer tree and keyboard handlers.
export default function IOSComposerKeyboard({ children }) { return children; }
